import React from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import { stypes } from "../common/common";

const DestinationItem = ({ stype, dest }) => {
	return (
		<Link to={`${stype === stypes.SD ? "" : "/withdriver"}/city/${dest.city}`}>
			<div className="fix-img car-glass" style={{ clipPath: "none" }}>
				<img loading="lazy" src={dest.imageV2} alt={`Cho thuê xe tự lái ${dest.name}`} />
			</div>
			<p>
				{dest.name} <span> {dest.totalCars} xe</span>
			</p>
		</Link>
	);
};

const Destination = ({ stype, topDests }) => {
	return (
		<React.Fragment>
			<div className="m-container">
				<h2>Địa Điểm Nổi Bật</h2>
			</div>
			<div className="m-container">
				<Swiper
					className="swiper-topdes-city"
					spaceBetween={10}
					slidesPerView={1.4}
					modules={[Navigation, Pagination]}
					pagination={{
						el: ".pagi-topdes",
						clickable: true,
						dynamicBullets: true,
					}}
					navigation={{
						nextEl: ".topdes-next",
						prevEl: ".topdes-prev",
					}}
					breakpoints={{
						992: {
							slidesPerView: 4,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 2.5,
							spaceBetween: 10,
						},
						481: {
							slidesPerView: 2,
						},
					}}>
					{topDests.map((dest) => (
						<SwiperSlide key={dest.city}>
							<DestinationItem dest={dest} stype={stype} />
						</SwiperSlide>
					))}
					<div className="swiper-pagination pagi-topdes" />
				</Swiper>
				<div className="swiper-button-prev topdes-prev" />
				<div className="swiper-button-next topdes-next" />
			</div>
		</React.Fragment>
	);
};

export default Destination;
